import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../button/button";

// import "./NavigationItems.css";
import "./conferences.css";

function ConferencesContainer(props) {
  return (
    <>
      <div id="conferencesPage" className="page">
        <h1>Conferences</h1>
        <hr />
        {props.isAuth && (
          <Button design="raised" mode="accent" onClick={props.onAddConference}>
            New conference
          </Button>
        )}
        <ul id="conferences-items">{props.children}</ul>
      </div>
    </>
  );
}

export default ConferencesContainer;
